export default __webpack_public_path__ + "static/media/strength-people-hands-success-meeting.9d6302e1.jpg";